// Full-render composition + bus subscriptions: the glue that repaints the
// screen when core state changes.

import { bus } from "../core/bus";
import { state } from "../core/state";
import { $ } from "./dom";
import { highlightOption, markPrefetchReady, refreshGroundingChips, renderNode } from "./card";
import { renderCoverage, renderMap } from "./map";

export function renderAll(): void {
  const node = state.nodes.get(state.currentId!);
  if (!node) return;
  renderNode(node);
  renderMap();
  renderCoverage();
  $("#main").scrollTop = 0;
}

export function wireRenderBus(): void {
  bus.on("render:all", () => renderAll());
  bus.on("render:node", ({ node, opts }) => renderNode(node, opts));
  bus.on("render:grounding", () => {
    // refill chips in place (no full card rebuild → the inject input keeps
    // its focus/text) and repaint the coverage bar
    refreshGroundingChips();
    renderCoverage();
  });
  bus.on("render:constraints", () => {
    // rebuild the current card so the chips appear without waiting for the
    // next navigation
    const n = state.nodes.get(state.currentId!);
    if (n) renderNode(n);
  });
  bus.on("prefetch:ready", ({ index }) => markPrefetchReady(index));
  bus.on("option:highlight", ({ index }) => highlightOption(index));
}
